var React = require('react');

function BreadcrumbBackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"svg-fill","fillRule":"evenodd","d":"M5.06465742,11.9664207 C4.92750431,11.9664207 4.79004976,11.9186276 4.67701148,11.820869 L0.214863158,7.95831724 C0.0786143541,7.84007586 -6.02870813e-05,7.6665931 -6.02870813e-05,7.48317931 C-6.02870813e-05,7.29976552 0.0786143541,7.12597241 0.214863158,7.00773103 L4.67701148,3.14517931 C4.9317244,2.92545517 5.31243732,2.95866207 5.52645646,3.22090345 C5.74077703,3.48345517 5.70761914,3.87511034 5.45290622,4.09576552 L1.53967177,7.48317931 L5.45290622,10.8705931 C5.70761914,11.0912483 5.74077703,11.4825931 5.52645646,11.7451448 C5.40708804,11.8913172 5.2364756,11.9664207 5.06465742,11.9664207","transform":"translate(0 -3)"}));
}

BreadcrumbBackArrow.defaultProps = {"width":"6","height":"9","viewBox":"0 0 6 9"};

module.exports = BreadcrumbBackArrow;

BreadcrumbBackArrow.default = BreadcrumbBackArrow;
